import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { menuStore } from 'src/mobx/menuStore';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import './style.scss';

interface IProps {
  branchId?: number;
}

@observer
export default class MenuCategoriesSearch extends Component<IProps, {}> {
  onChange = (search: string) => {
    menuStore.setParameters({ search, branch_id: this.props.branchId });
  };

  changeSearchState = (isActive: boolean) => {
    if (menuStore.parameters.search) return;
    menuStore.changeSearchActiveStatus(isActive);
    if (!isActive) {
      delete menuStore.parameters.search;
    }
  };

  render() {
    return (
      <SearchInput
        onChangeText={this.onChange}
        withResetIcon
        value={menuStore.parameters.search}
        onFocus={() => this.changeSearchState(true)}
        onBlur={() => this.changeSearchState(false)}
        loading={menuStore.loading}
        className={`menu-search ${menuStore.isSearchActive ? 'menu-search-expanded' : ''}`}
        inputClassName="menu-search__input input input-mini family-regular border-gray  text-size-16"
        placeholder={localeStore.t('txt_search')}
      />
    );
  }
}
